import styled, { createGlobalStyle } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { NavLink } from "react-router-dom"

export const GlobalStyles = createGlobalStyle`
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    height: 100vh;
    width: 100%;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.body.family}, sans-serif;
    font-weight: ${(props) => props.theme.fonts.body.weight};
    margin: 0;
    padding: 0;
  }

  @supports (-webkit-touch-callout: none) {
    html {
      height: -webkit-fill-available !important;
    }
  }

  body {
    background-color: ${(props) => props.theme.colors.brand};
    color: ${(props) => props.theme.colors.body};
    margin: 0;
    padding: 3rem;

    ${breakpoint("desktop")`
      overflow-x: hidden;
    `}
  }
`

export const Content = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
`

export const Code = styled.div`
  font-family: ${(props) => props.theme.fonts.headings.family}, sans-serif;
  font-weight: ${(props) => props.theme.fonts.headings.weight};
  font-size: 9rem;
  text-align: center;

  ${breakpoint("desktop")`
    font-size: 12rem;
  `}
`

export const Text = styled.div`
  font-family: ${(props) => props.theme.fonts.headings.family}, sans-serif;
  font-weight: ${(props) => props.theme.fonts.headings.weight};
  font-size: 1.75rem;
  text-align: center;

  ${breakpoint("desktop")`
    font-size: 2.5rem;
  `}
`

export const Link = styled(NavLink)`
  font-family: ${(props) => props.theme.fonts.headings.family}, sans-serif;
  font-weight: ${(props) => props.theme.fonts.headings.weight};
  font-size: 1.75rem;
  text-align: center;
  color: ${(props) => props.theme.colors.body};
  margin-top: 1rem;

  &:hover {
    text-decoration: none;
  }

  ${breakpoint("desktop")`
    font-size: 2.5rem;
  `}
`
